<template>
  <NormalHeaderLayout header="">
    <div class="single-widget">
      <Spinner v-if="loading || (resultExist && !widgetSpecReady)"></Spinner>
      <template v-if="isWidgetReady">
        <div class="card">
          <div :id="widgetSelector" class="card-body"></div>
        </div>
      </template>
    </div>
  </NormalHeaderLayout>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import NormalHeaderLayout from '../components/layout/NormalHeaderLayout.vue';
import Spinner from '../components/ui/Spinner.vue';

export default {
  name: 'SingleWidget',

  components: {
    NormalHeaderLayout,
    Spinner,
  },

  data() {
    return {
      widgetId: '',
      resource: '',
      widgetSpecReady: false,
      widgetSelector: '',
    };
  },

  computed: {
    ...mapState(['searchResult']),
    ...mapGetters(['loading', 'resultExist', 'currentTab']),

    isWidgetReady() {
      return this.resultExist && this.widgetSpecReady;
    },
  },

  watch: {
    isWidgetReady(bool) {
      if (bool) {
        // loop this.searchResult and init the widgets
        for (const i of this.searchResult) {
          i.widgets.forEach((widget) => {
            if (this.widgetId === widget.id) {
              const { widgetName, params, selector, styling } =
                widget.widgetObject;
              this.widgetSelector = selector;

              // wait for the dom render first
              // jquery need the dom to be ready
              this.$nextTick(() => {
                window.ripestat.init(widgetName, params, selector, styling);
              });
            }
          });

          if (this.widgetSelector) break;
        }
      }
    },
  },

  mounted() {
    this.widgetId = this.$route.params.widgetId;
    this.resource = this.$route.hash.split('resource=')[1];

    // if widgetId or resource is not available from URL, do not proceed.
    if (!this.widgetId || !this.resource) return;

    this.startSearch();
    this.checkWidgetSpec();
  },

  methods: {
    startSearch() {
      this.$store.dispatch('searchResource', this.resource);
    },

    checkWidgetSpec() {
      if (window.STAT_WIDGETS_SPEC) {
        this.widgetSpecReady = true;
      } else {
        setTimeout(() => this.checkWidgetSpec(), 500);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@include widget-card;

.single-widget {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 1rem;
}

.card {
  width: 100%;
}

.card-body {
  width: 100% !important;
}
</style>
